var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"max-w-[1500px] -mt-8 m-auto w-full text-bleu text-3xl leading-8"},[(_vm.lot === 'br')?_c('BrElem',{attrs:{"already":_vm.already}}):_vm._e(),(_vm.lot === 'sacatarte')?_c('SacElem',{attrs:{"already":_vm.already}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }